function CookieNotificationController ($cookies, $timeout)
{
    'ngInject';

    var vm = this;
    var cookieTimer = null;
    var cookieName = 'termsOfUseCookie';

    vm.isVisible = false;

    function setCookie() {
        $cookies.put(cookieName, 'true');
    }

    vm.AcceptTerms = function () {
        setCookie();
        vm.isVisible = false;
        if (cookieTimer) {
            $timeout.cancel(cookieTimer);
        }
    };

    vm.$onInit = function() {
        var cookieExists = $cookies.get(cookieName) === 'true';
        vm.isVisible = !cookieExists;

        if (vm.isVisible) {
            cookieTimer = $timeout(function () {
                vm.AcceptTerms();
            }, 4000);
        }
    };

    vm.$onDestroy = function () {
        if (cookieTimer) {
            $timeout.cancel(cookieTimer);
        }
    };
}

module.exports = CookieNotificationController;